export const resetState = (state) => {
  state.user = {};
  state.loginUserToken = '';
  state.customerQuotation = {};
  //state.tempQuotationPayment = false;
  //state.sessionResponseData = {};
  //state.prePaymentData = {};
}

export const setUser = (state, user) => {
  state.user = user
  if(state.user.middle_name == '' || state.user.middle_name == null || state.user.middle_name == 'null') {
    state.user.middle_name = '';
  }
}

export const setLoginUserToken = (state, token) => {
  state.loginUserToken = token;
}

export const logOutUser = (state) => {
  state.user = {};
  state.loginUserToken = '';
}

export const setOTPVerified = (state) => {
  state.user.otp_verified = 1;
}

export const setUsernameVerified = (state) => {
  state.user.username_verified = 1;
}

export const setEmailVerified = (state) => {
  state.user.email_verified_at = 1;
}

export const setUsername = (state, username) => {
  state.user.username = username;
}

export const updateUserMobileNumber = (state, mobileNumber) => {
  state.user.mobile_no = mobileNumber;
}

export const updateUserEmail = (state, email) => {
  state.user.email = email;
}

export const setCustomerQuotation = (state, quotation) => {
  state.customerQuotation = quotation;
}

export const resetCustomerQuotation = (state) => {
  state.customerQuotation = {};
}

export const resetQuotationData = (state) => {
  state.customerQuotation = {};
}

export const setQuotationPayment = (state) => {
  state.tempQuotationPayment = true;
}

export const resetQuotationPayment = (state) => {
  state.tempQuotationPayment = false;
}

export const resetQuotationTempData = (state) => {
  state.tempQuotationPayment = false;
  state.prePaymentData = {};
  state.sessionResponseData = {};
}

export const setSessionResponse = (state, response) => {
  state.sessionResponseData = response;
}

export const resetSessionResponse = (state) => {
  state.sessionResponseData = {};
}

export const setPrePaymentData = (state, data) => {
  state.prePaymentData = data;
}

export const resetPrePaymentData = (state) => {
  state.prePaymentData = false;
}

export const setSignupRedirect = (state) => {
  state.signupRedirect = true;
}

export const resetSignupRedirect = (state) => {
  state.signupRedirect = false;
}



// WEBPACK FOOTER //
// ./src/store/modules/mutations.js